module.exports = __webpack_public_path__ + "img/sns.fee76fe9.png";